import React from "react";
import CallToActionBanner from "../components/CallToActionBanner";

const AboutPage = () => {
  return (
    <div className="text-gray-800">
      {/* Hero Section */}
      <section className="bg-primary text-white py-20 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold">About "New Krishna Technology"</h1>
        <p className="mt-4 text-white/90 text-lg max-w-2xl mx-auto">
          Empowering businesses with secure, reliable, and scalable IT networking solutions since 2010.
        </p>
      </section>

      {/* Company Story with Image */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Who We Are</h2>
            <p className="text-gray-600 text-base leading-relaxed">
              "New Krishna Technology" is a professionally managed IT infrastructure and networking company committed to delivering end-to-end connectivity solutions.
              With over 15 years of industry experience, we’ve built a strong reputation for deploying scalable, secure, and efficient network environments
              for clients across diverse industries.
            </p>
            <p className="text-gray-600 mt-4">
              From network design and firewall integration to wireless deployment and AMC support, our certified engineers ensure every solution is
              tailored to your needs and future-ready.
            </p>
          </div>
          <div>
            <img
              src="/assets/about-team.png"
              alt="Our Team"
              className="rounded-lg shadow-md w-full object-cover h-72"
            />
          </div>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold mb-8 text-center">Our Journey in Pictures</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
            <img
              src="/assets/about-infra.png"
              alt="Infrastructure"
              className="rounded-lg object-cover h-60 w-full shadow-sm"
            />
            <img
              src="/assets/about-work.png"
              alt="On-Site Deployment"
              className="rounded-lg object-cover h-60 w-full shadow-sm"
            />
            <img
              src="/assets/about-office.png"
              alt="Our Office"
              className="rounded-lg object-cover h-60 w-full shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          <div>
            <h3 className="text-2xl font-semibold mb-3">Our Mission</h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              To provide cutting-edge IT networking and security solutions that empower businesses to thrive in the digital era.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-3">Our Vision</h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              To be recognized as a trusted technology partner known for reliability, innovation, and long-term client success.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <CallToActionBanner />
    </div>
  );
};

export default AboutPage;
